// START IMPORTS
import { createTheme } from '@ltvco/refresh-lib/theme';
// END IMPORTS

// START CONSTANTS
export const theme = createTheme({
  typography: {
    button: { textTransform: 'none', fontSize: '1rem', fontWeight: 'bold' },
    fontSize: 16,
    htmlFontSize: 16,
    fontFamily: "'Nunito Sans', sans-serif",
    h1: {
      fontSize: '1.875rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 'bold',
      margin: '0 0 12px 0',
      lineHeight: 1.2,
    },
    caption: {
      letterSpacing: 0,
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.2,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.2,
    },
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          backgroundColor: '#fff',
          '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: '#fff',
          },
          '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
            backgroundColor: '#F8F8F8',
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          // padding: 0,
          // px: 14,
          // py: 12,
          borderRadius: 32,

          '&.smart-insights-button': {
            backgroundImage:
              'linear-gradient(to right, rgba(99,138,58,1) 0%, rgba(129,180,76,1))',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: () => ({
          '&.unrecorded-item': {
            color: '#638A3A',
          },
          '&.hidden-section-icon': {
            color: '#0052FF',
          },
        }),
        colorPrimary: {
          color: '#0052FF',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#E2E2E2',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            padding: 12,
          },
          div: {
            height: 40,
            backgroundColor: '#fff',
          },
          '& .MuiFormLabel-root': {
            top: -8,
          },
          '& .Mui-focused': {
            top: 0,
          },
          '& .MuiFormLabel-filled': {
            top: 0,
          },
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: () => ({
          '&.smart-insights-badge': {
            backgroundImage: `linear-gradient(to right, #638A3A 0%, #81B44C)`,
          },
        }),
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: () => ({
          backgroundColor: '#E6E7E9 !important',
          '&.dark-mode': {
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
          },
        }),
      },
    },
  },
  palette: {
    button: {
      main: '#0052FF',
      light: '#E5EEFF',
      dark: '#003099',
      contrastText: '#FFFFFF',
    },
    buttonInverse: {
      main: '#FFFFFF',
      contrastText: '#0A0B0D',
      light: '#0A0B0D',
      dark: '#FFFFFF',
    },
    rats: {
      main: '#5B616E',
      light: '#F8F8F8',
      dark: '#0052FF',
      contrastText: '#F8F8F8',
      activeHover: '#003099',
      disabled: '#929AAB',
    },
    divider: '#E6E7E9',
    primary: {
      main: '#0052FF',
      light: '#e5eeff',
      dark: '#003099',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#2196F3',
      light: '#64b5f6',
      dark: '#1976d2',
      contrastText: '#FFFFFF',
    },
    // secondary: {
    //   main: '#E6E7E9',
    //   light: '#ebeaf4',
    //   dark: '#E6E7E9',
    //   contrastText: '#0A0B0D',
    // },
    success: {
      main: '#4caf50',
      light: '#EDF9EF',
      dark: '#388e3c',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ED6C02',
      light: '#F08934',
      dark: '#9A000E',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#DC0015',
      light: '#FFEDEA',
      dark: '#9A000E',
      contrastText: '#FFFFFF',
    },
    background: {
      paper: '#fff',
      default: '#F8F8F8',
      light: '#E6E7E9',
    },
    text: {
      primary: '#0A0B0D',
      secondary: '#5B616E',
      disabled: '#929AAB',
      contrastText: '#fff',
    },
    barChart: {
      main: '#4A3B8F',
      light: '#939FC8',
      dark: '#D3D3D7',
      contrastText: '#000',
    },
    lineChart: {
      main: '#4A3B8F',
      light: '#757575',
      dark: '#DC0015',
      contrastText: '#000',
    },
    charts: {
      primary: '#4C8DFF',
      secondary: '#5D4BFF',
      tertiary: '#1DA29A',
      positive: '#3CB963',
      caution: '#E46C0A',
      critical: '#FF3D3D',
      accent: '#D85FA6',
      decorative: '#00B8D9',
    },
    maps: {
      main: '#1F2E64',
      light: '#3388FF',
      contrastText: '#FFF',
    },
    notistackToast: {
      main: '#008000',
      light: '#DEFCE6',
      dark: '#005000',
      contrastText: '#000',
    },
    neighborhoodWatch: {
      main: '#0052FF',
      light: '#DC0015',
      dark: '#0052FF',
      contrastText: '#fff',
    },
    marketInsights: {
      main: '#4A3B8F',
      light: '#edebff',
      dark: '#4A3B8F',
      contrastText: '#fff',
    },
    progress: {
      main: '#4A3B8F',
      light: '#757575',
      dark: '#DC0015',
      contrastText: '#E2E2E2',
    },
    premium: {
      main: '#FCC41C',
      contrastText: '#000',
    },
    listingPins: {
      main: '#EC413D',
      light: '#4AA351',
      dark: '#4A3B8F',
      contrastText: '#81b44c',
    },
    listingPinsVisited: {
      main: '#f8a09e',
      light: '#9FCBA2',
      dark: '#9F97C1',
    },
    crimePins: {
      property: '#FF6B6B',
      person: '#4ECDC4',
      society: '#B66DFF',
      default: '#95A5A6',
      hover: '#000000',
    },
    aiCrimeInsights: {
      gradientStart: '#E100FF',
      gradientEnd: '#0052FF',
    },
    parcelBoundaries: {
      main: '#FFFFFF',
      dark: '#000000',
    },
    aiChip: {
      main: '#81B44C',
      light: '#9F44EB',
      contrastText: '#fff',
    },
    propertySmartinsights: {
      main: '#2A0345',
    },
    upgradeCheck: {
      main: '#74ad47',
    },
    reportSectionSupertitleBackgroundColor: {
      main: '#0052FF',
    },
    threatDetection: {
      main: '#DC0015',
      light: '#E1FAEA',
      dark: '#81B44C',
      contrastText: '#FFF1F1',
    },
    labelsAndLinks: {
      main: '#757575',
    },
    chatbot: {
      main: '#4a3b8f',
      contrastText: '#81B44C',
    },
    familyTreeChart: {
      border: '#84a4f5',
      borderActive: '#4caf50',
      fillActive: '#81c784',
      // Filled node cards and the lines joining them
      nodeBorder: '#C2BFBC',
      connectorLine: '#4D4D4D',
      // Accent for the tree's own buttons and links
      button: '#0052FF',
      // Outline of the tree subject's card
      treeSubjectBorder: '#4CAF50',
      // Empty (placeholder) nodes: plus glyph and label color, and the flat
      // fills they take while a node is being picked to place a relative
      // (blue) or to add a generation (brown).
      placeholderAccent: '#0052FF',
      placementFill: '#DDE5FA',
      expandBorder: '#508c46',
      expandFill: '#e5efe5',
      expandAccent: '#508c46',

      placeholderDisabled: '#9E9E9E',
    },
    familyMap: {
      background: '#68C5EC',
      defaultPersonMarker: '#0052FF',
      defaultEventMarker: '#ED6C02',
    },
    familyPhotosPage: {
      background: {
        gradient1: '#00FFF2',
        gradient2: '#0052FF',
        gradient3: '#5C65E6',
      },
    },
    memberProfile: {
      background:
        'linear-gradient(100.31deg, rgba(0, 82, 255, 0.05) 0%, rgba(0, 82, 255, 0.3) 55%, rgba(81, 0, 255, 0.1) 100%)',
    },
    reactivation: {
      main: '#092049',
      light: '#DBF4DC',
      dark: '#405883',
      contrastText: '#FFF8F3',
    },
    familyTreeOnboarding: {
      background: 'rgba(22, 106, 243, 0.2)',
      contrastText: '#5B616E',
      getStartedHeaderGradient: {
        gradient1: '#E3F0FF',
        gradient2: '#c8c6fb',
        gradient3: '#b3c7fa',
      },
    },
    familyDashboard: {
      icons: '#0052FF',
      featureCardBackground: '#F8F8F8',
    },
    neighborhoodReport: {
      success: '#4CAF50',
      warning: '#FFC107',
      error: '#F44336',
      compareSecondaryAccent: '#4A3B8F',
      compareSecondaryAccentHover: '#3a2e7a',
      compareSecondaryBg: '#ECE9F6',
    },
    deceasedSearchBanner: {
      gradient1: '#0052ff33',
      gradient2: '#00999133',
    },
    monitoringCenter: {
      countCardsColors: [
        {
          background: '#FFF6EE',
          accent: '#F08934',
        },
        {
          background: '#F0F9F0',
          accent: '#4CAF50',
        },
        {
          background: '#FEF2F8',
          accent: '#D85FA6',
        },
        {
          background: '#F2F1FF',
          accent: '#5D4BFF',
        },
      ],
      listBackground: '#F8F8F8',
      cardBackground: '#E6E7E9',
      iconColor: '#0052FF',
      tableHeaderColor: '#5B616E',
    },
  },
});
// END CONSTANTS
